import {useParams} from 'react-router';
import React, {useEffect} from 'react';

import {useEvent} from '../../../../data/hooks/eventHooks';
import CloseButton from './CloseButton';
import MaximizeButton from './MaximizeButton';

const SidePanelToolbar = props => {
    const {onClose} = props,
        {eventId} = useParams(),
        event = useEvent(eventId);

    useEffect(() => {
        document.querySelector('#splitScreen').classList.add('has-toolbar');
        return () => {
            document.querySelector('#splitScreen').classList.remove('has-toolbar');
        };
    });

    return (
        <div className={['SidePanelToolbar'].join(' ')} style={{background: event?.settings.primary_color}}>
            <nav>
                <MaximizeButton />
                {onClose ? (
                    <CloseButton onClose={onClose} />
                ) : null}
                {props.children}
            </nav>
        </div>
    );
};

export default SidePanelToolbar;
